import React, {useContext, useState} from 'react';
import {useTranslation} from "react-i18next";
import {VoucherProductsContext} from "../../services/VoucherProducts/VoucherProductsContext";
import ItemHelper from "../../services/Menu/services/Item/ItemHelper";
import IframeWidget from "../../utils/IframeWidget";
import {Modal} from "react-bootstrap";
import MenuShowItemSingleComponent from "../../pages/Menu/components/Item/MenuShowItemSingleComponent";
import {RootState} from "../../../reducers";
import {getItemGroups, getItems, getMenus} from "../../services/Menu/reducer";
import {getCart} from "../../services/Cart/reducer";
import {getVouchers} from "../../services/User/reducer";
import {connect, DispatchProp} from "react-redux";

interface OwnProps {
    itemId: number;
    menuId: number;
    show: boolean;
    onHide: () => void;
    preventRemovePromotionOnHide?: boolean;
}

type Props = ReturnType<typeof mapStateToProps> & DispatchProp & OwnProps;

const PromotionItemAddModal = ({
                                   items,
                                   menus,
                                   itemId,
                                   menuId,
                                   itemGroups,
                                   show,
                                   onHide,
                                   preventRemovePromotionOnHide
                               }: Props) => {
    const [isShown, setIsShown] = useState(show);
    const {t} = useTranslation();
    const {handleOnPromotionLimit, handleRemovePromotion} = useContext(VoucherProductsContext);
    const menusById = menus.filter((menu: any) => menu.id === menuId);
    const item = ItemHelper.getItem(items, itemId);
    let menu = undefined;
    const itemGroup = ItemHelper.getItemGroup(itemGroups, item.id);

    if (menusById.length > 0) {
        menu = menusById[0];
    }

    if (!item) return null;

    let productImgView = null;

    const addItem = async (addedItem: any, addedMenuId: any) => {
        await hideModal(addedItem, addedMenuId);
    }

    const hideModal = async (addedItem: any, addedMenuId: any) => {
        onHide();

        const isItemInCart = addedItem?.item_id === item.id;

        if (!isItemInCart && !preventRemovePromotionOnHide) {
            await handleRemovePromotion();
        }

        handleOnPromotionLimit(addedItem);

        setIsShown(false);
    };

    if (item.image_link) {
        productImgView = (
            <div className="product-item-img">
                <img src={item.image_link.default} alt={t("common.word.product_image")}/>
            </div>
        )
    }

    const handleOnMenuShowItemHide = () => {
        onHide();
        setIsShown(false);
    }

    return (
        <Modal dialogClassName={"modal-full modal-product modal-product-full"} show={isShown}
               aria-labelledby="menu_item_base_modal_title"
               onHide={() => IframeWidget.onHide(handleOnMenuShowItemHide)} onShow={() => IframeWidget.onShow()}>
            <div className={"modal-product-content"}>
                {productImgView}
                <div className={"modal-product-full-right"}>
                    <div className={"container-fluid"}>
                        <MenuShowItemSingleComponent itemId={item.id} itemGroup={itemGroup} onUpdate={addItem}
                                                     menu={menu}
                                                     onHide={() => IframeWidget.onHide(handleOnMenuShowItemHide)}/>
                    </div>
                </div>
            </div>
        </Modal>
    )
}

const mapStateToProps = (state: RootState) => ({
    items: getItems(state.menu),
    itemGroups: getItemGroups(state.menu),
    menus: getMenus(state.menu),
    cart: getCart(state.cart),
    vouchers: getVouchers(state.user),
})

const connector = connect(mapStateToProps);

export default connector(PromotionItemAddModal);